module.exports = __webpack_public_path__ + "_assets/img/video-c.753d0671.svg";